const user_management = {
	dialog: {
		add_user_first_impersonate: {
			alert:
				"Um einen Benutzer hinzuzufügen, müssen Sie zunächst einen Administrator des Schuldners <strong>{{debtor_code}}</strong> imitieren.",
			to_impersonate_page_button: "Zur Imitationsseite gehen",
		},
		block: {
			description:
				"Sind Sie sicher, dass Sie den Benutzer <strong>{{username}}</strong> blockieren möchten?",
			success_alert: "Benutzer erfolgreich blockiert!",
			title: "Benutzer blockieren",
		},
		deblock: {
			description:
				"Sind Sie sicher, dass Sie den Benutzer <strong>{{username}}</strong> freigeben möchten?",
			success_alert: "Benutzer erfolgreich freigegeben!",
			title: "Benutzer freigeben",
		},
		delete: {
			delete_last_admin:
				"Ich bin mir bewusst, dass ich damit den letzten Admin-Benutzer des Schuldners <strong>{{Schuldner}}</strong> lösche.",
			description:
				"Sind Sie sicher, dass Sie den Benutzer <strong>{{username}}</strong> löschen möchten?",
			otp_invalid: "Ungültiger 2FA-Code!",
			otp_not_enabled:
				"Bevor Sie Benutzer löschen können, müssen Sie zuerst die Zwei-Faktor-Authentifizierung (2FA) aktivieren.",
			success_alert: "Benutzer erfolgreich gelöscht!",
			title: "Benutzer löschen",
		},
		disable_otp: {
			description:
				"Bist du sicher, dass du 2FA für <strong>{{user}}</strong> deaktivieren möchtest?",
			messages: {
				success: "2FA erfolgreich entfernt für <strong>{{user}}</strong>!",
			},
			otp_first: "Aktiviere zuerst 2FA, bevor du es für einen Benutzer deaktivieren kannst.",
			otp_invalid: "Ungültiger 2FA-Code!",
			otp_not_enabled: "2FA ist für diesen Benutzer nicht aktiviert",
			submit_button: "Deaktivieren",
			title: "2FA deaktivieren",
		},
		impersonate: {
			description:
				"Sind Sie sicher, dass Sie den Benutzer <strong>{{username}}</strong> imitieren möchten?",
			otp_invalid: "Ungültiger 2FA-Code!",
			otp_not_enabled:
				"Bevor Sie Benutzer imitieren können, müssen Sie zuerst die Zwei-Faktor-Authentifizierung (2FA) aktivieren.",
			title: "Benutzer imitieren",
		},
	},
	membership_type: {
		business: "Business",
		label: "Wähle Schuldnertyp",
		private: "Private",
	},
	show_disabled: "Gelöschte Benutzer anzeigen",
	table: {
		body: {
			buttons: {
				block: "Blockieren",
				deblock: "Freigeben",
				impersonate: "Imitieren",
			},
			otp: {
				disabled: "2FA deaktiviert",
				enabled: "2FA aktiviert",
			},
		},
		headers: {
			categories: "Labels",
			company: "Firmenname",
			debtor_code: "Schuldner-Nummer",
			email_address: "E-Mail-Adresse",
			language: "Sprache",
			membership_type: "Kontotyp",
			otp: "2FA",
			phone_number: "Telefonnummer",
			user_id: "Benutzer-ID",
			username: "Benutzername",
		},
	},
	title: "Benutzer",
};

export default user_management;
